import React from 'react';
import Modal from 'components/ui/modal';
import View from 'components/ui/view';
import Text from 'components/ui/text';

class CartItemEngraving extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editing: false };
  }

  updateEngraving(updatedLines) {
    return this.props
      .updateEngraving({
        ...this.props.engraving,
        ...updatedLines
      })
      .then(() => {
        this.setState({ editing: false });
      });
  }

  render() {
    const { item, engraving } = this.props;
    if (!engraving) return null;

    return (
      <div className="cart-item__engraving">
        <hr className="light" />
        <span
          className="link-text text-secondary right"
          onClick={() => this.setState({ editing: true })}
        >
          Edit
        </span>
        <div className="cart-item__title">
          <span className="text-bold">Engraving </span>
          <span className="cart-item__price">
            (+${engraving.subtotal.toFixed(2)})
          </span>
        </div>
        {!!engraving.line_1 && <div>{engraving.line_1}</div>}
        {!!engraving.line_2 && <div>{engraving.line_2}</div>}
        {!!engraving.line_3 && <div>{engraving.line_3}</div>}

        {this.state.editing && (
          <EditEngravingModal
            item={item}
            engraving={engraving}
            isOpen={this.state.editing}
            close={() => this.setState({ editing: false })}
            updateEngraving={engraving => this.updateEngraving(engraving)}
            removeEngraving={engraving => this.props.removeEngraving(engraving)}
            disabled={this.props.disabled}
            checkout={this.props.checkout}
          />
        )}
      </div>
    );
  }
}

class EditEngravingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      line_1: props.engraving.line_1,
      line_2: props.engraving.line_2,
      line_3: props.engraving.line_3
    };
    this.setLine1 = this.setLine.bind(this, 1);
    this.setLine2 = this.setLine.bind(this, 2);
    this.setLine3 = this.setLine.bind(this, 3);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
  }

  setLine(n, event) {
    this.setState({ [`line_${n}`]: event.target.value });
  }

  save(e) {
    e.preventDefault();
    this.props.updateEngraving({
      line_1: this.state.line_1,
      line_2: this.state.line_2,
      line_3: this.state.line_3
    });
  }

  remove() {
    this.props.removeEngraving(this.props.engraving, {
      checkout: this.props.checkout
    });
  }

  render() {
    const item = this.props.item;

    return (
      <Modal
        isOpen={this.props.isOpen}
        handleClose={() => this.props.close()}
        className="cart-item__engraving-modal"
      >
        <View padding="sm">
          <View margin="sm" className="text-center">
            <View padding="xs">
              <img src={item.image} className="cart-item__thumbnail" />
            </View>
            <Text title weight="med">
              Engraving for
            </Text>
            <Text title weight="med">
              {item.title}
            </Text>
            <Text title weight="med">
              {item.subtitle}
            </Text>
          </View>

          <form onSubmit={this.save}>
            <View margin="sm">
              <input
                type="text"
                className="product-engraving__input"
                value={this.state.line_1}
                onChange={this.setLine1}
                placeholder="Enter text (20 character max per line)"
                maxLength={20}
              />
              <input
                type="text"
                className="product-engraving__input"
                value={this.state.line_2}
                onChange={this.setLine2}
                maxLength={20}
              />
              <input
                type="text"
                className="product-engraving__input"
                value={this.state.line_3}
                onChange={this.setLine3}
                maxLength={20}
              />
            </View>
            <button
              className="btn-primary green btn--full-width"
              type="submit"
              disabled={this.props.disabled}
            >
              Save
            </button>
          </form>

          <View margin="xs">
            <button
              onClick={this.remove}
              className="btn-small btn--inline link-text--secondary"
              disabled={this.props.disabled}
            >
              Remove Engraving
            </button>
          </View>
        </View>
      </Modal>
    );
  }
}

export default CartItemEngraving;



// WEBPACK FOOTER //
// ./shared/components/cart/engraving.js